var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"service-container",staticStyle:{"margin-top":"8px"}},[_c('img',{staticClass:"service-main-img",attrs:{"src":require("@/assets/img/多肽服务.png"),"alt":"多肽服务主图","loading":"eager"}})])])
}]

export { render, staticRenderFns }